import React from "react";
const Heading = ({ children, className = "", variant = "default" }) => {
  const variants = { default: "text-[#001A3D]", white: "text-white" };
  return (
    <h2
      className={`${className} leading-[120%] text-custom-5xl font-bold max-lg:text-custom-4xl max-md:text-custom-3xl ${variants[variant]}  `}>
      {children || "Heading"}
    </h2>
  );
};
export default Heading;
